module.exports = __webpack_public_path__ + "static/Rosewater6-9cdc21e2caa995ec9da637a9f30bc3b7.png";